import dataProvider from '@/api'

export default {
  /**
   * @description Создание заказа
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/CreateOrder
   *
   * @param {object} payload
   *
   * @returns {object}
   */
  postOrders (payload = {}) {
    return dataProvider.post('/orders', payload)
  },

  /**
   * @description DEV-16832 Метод для создания заказа с драфтом
   */
  postOrdersDraft (payload = {}) {
    return dataProvider.post('/orders/draft', payload)
  },

  /**
   * @description DEV-16832 Метод для подтверждения заказа с драфтом
   *
   * @param {object} payload
   * @param {boolean} payload.isAutolongationEnabled
   *
   * @returns {object}
   */
  completeOrderDraft (payload = {}) {
    return dataProvider.post('/orders/draft/complete', payload)
  },

  /**
   * @description DEV-16960 Назначаем сегмент по аб для автопродлений
   */
  postCheckout (payload) {
    return dataProvider.post('/orders/checkout', payload)
  },

  /**
   * @description DEV-16960 Отправка запроса для изменения состояния автопродления
   *
   * @param {object} payload
   * @param {string} payload.order.Id_H
   * @param {boolean} payload.isEnable
   *
   * @returns {object}
   */
  postChangeAutolongate (payload) {
    return dataProvider.post('/orders/change-autolongate', payload)
  },

  /**
   * @description Получение заказа по его ID
   *
   * @param {object} payload
   * @param {string} payload.orderIds_HU
   * @return {object}
   */
  getOrder (payload = {}) {
    return dataProvider.get('/orders', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/OrdersCustomizationAdd
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrderCustomizationAdd (payload = {}) {
    return dataProvider.post('/orders/customization/add', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/OrdersLongate
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrdersLongate (payload = {}) {
    return dataProvider.post('/orders/longate', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/OrdersActive
   *
   * @returns {object}
   */
  getOrdersActive () {
    return dataProvider.get('/orders/active')
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/forgotToOrder
   *
   * @param {object} payload
   * @param {object} payload.order - required
   * @param {number} payload.order.pricePlanId
   * @param {number} payload.order.mealDays
   *
   * @returns {object}
   */
  postOrdersForgotToOrder (payload = {}) {
    return dataProvider.post('/orders/forgot-to-order', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/DropMajorDraft
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrdersCustomizationDropMajor (payload = {}) {
    return dataProvider.post('/orders/customization/drop-major', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/AcceptDraftConfig
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrdersCustomizationAccept (payload = {}) {
    return dataProvider.post('/orders/customization/accept', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/DropDraftConfig
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrdersCustomizationDrop (payload = {}) {
    return dataProvider.post('/orders/customization/drop', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/DropUnacceptedDraftConfig
   *
   * @param {object} payload
   * @param {string} payload.orderId_H - required
   *
   * @returns {object}
   */
  postOrdersCustomizationDropUnAccepted (payload = {}) {
    return dataProvider.post('/orders/customization/drop-unaccepted', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/MenuOrder
   *
   * @param {object} payload
   * @param {string} payload.OrderId_H - required
   * @param {boolean} payload.isDraft
   *
   * @returns {object}
   */
  getMenuOrder (payload = {}) {
    return dataProvider.get('/menu/order', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/MenuCustomization
   *
   * @param {object} payload
   * @param {string} payload.OrderId_H - required
   *
   * @returns {object}
   */
  getMenuCustomization (payload = {}) {
    return dataProvider.get('/menu/customization', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%97%D0%B0%D0%BA%D0%B0%D0%B7%D1%8B/MenuFull
   *
   * @param {object} payload
   * @param {string} payload.OrderId_H - required
   * @param {array} payload.filterIds
   *
   * @returns {object}
   */
  postMenuFull (payload = {}) {
    return dataProvider.post('/menu/full', payload)
  },

  /**
   * @description Проверка процесса оплаты
   */
  getPaymentProcessing (payload) {
    return dataProvider.get(
      `/orders/is-payment-processing?orderId_H=${payload}`,
    )
  },

  /**
   * @description Детализация оплаты
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.13#/%D0%94%D0%B5%D1%82%D0%B0%D0%BB%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B/OrdersPayDetails
   *
   * @param payload
   * @param payload.OrderId_H - required
   * @param payload.orderId_H - required
   *
   * @return {object}
   */
  getOrdersPayDetails (payload = {}) {
    return dataProvider.get('/orders/pay-details', payload)
  },

  /**
   * @param payload
   * @param {String} payload.orderId_H айди заказа
   * @description Получение доступных интервалов и каналов подтверждения для заказа
   * @return {object}
   */
  getConfirmTaskOptions (payload = {}) {
    return dataProvider.get(
      `/orders/confirm-task/options?orderId_H=${payload.orderId_H}`,
      payload,
    )
  },
  /**
   * @param payload
   * @param {Object} payload.confirmTaskData объект с данными для запроса
   * @param {String} payload.confirmTaskData.orderId_H айди заказа
   * @param {String} payload.confirmTaskData.intervalId_H айди интервала
   * @param {String} payload.confirmTaskData.channelId_H айди заказа
   * @description Выбор канала и интервала подтверждения заказа
   */
  setConfirmTask (payload) {
    return dataProvider.post('orders/confirm-task', payload.confirmTaskData)
  },

  /**
   * @param payload
   * @param {Object} payload.cancelTaskData.orderId_H айди заказа
   * @description Удаление канала и интервала подтверждения заказа
   */
  cancelConfirmTask (payload) {
    return dataProvider.post(
      'orders/confirm-task/cancel',
      payload.cancelTaskData,
    )
  },

  createAbstractPseudoOrder (payload) {
    return dataProvider.post('/orders/pseudo-order', payload)
  },

  postOrdersCreateQuick (payload) {
    return dataProvider.post('/orders/create/quick', payload)
  },

  /**
   * @param payload
   * @param {Object} payload.order информация о заказе
   * @param {Number} payload.order.mealDays количество дней питания, которые выбрал пользователь
   * @param {Number} payload.order.order_origin_id id созданного заказа
   * @param {String} payload.order.phone номер телефона клиента
   * @param {Number} payload.order.price_plan_id количество дней питания, которые выбрал пользователь
   * @param {Object} payload.client информация о клиенте
   * @param {Number} payload.client.cityId город указанный клиентом
   * @param {String} payload.client.phone номер телефона клиента
   * @param {String} payload.promocode промокод клиента
   * @param {Number} payload.delayInMinutes ? задержка
   * @description Создание заказа после ввода телефона без отправки. Создает забытый заказ клиенту, когда тот посмотрел меню и не заказал.
   */
  createForgottenOrder (payload) {
    return dataProvider.post('/orders/forgot-to-order', payload)
  },

  /**
   * @param payload
   * @param {Number} payload.orderId id созданного заказа
   * @description Отсрочка перезвона для клиента, если он что-то делает на сайте
   */
  trackOrderFlowClientActivity (payload) {
    return dataProvider.get(`/orders/fresh-activity?orderId_H=${payload.orderId}`) //
  },

  /**
   * @param payload
   * @param {Number} payload.phone номер телефона
   * @param {String} payload.recaptchaToken
   * @description Создание заказа Welcome Set
   */
  createWelcomeSetOrder (payload) {
    return dataProvider.post('/orders/create/welcome-set', payload)
  },
}
